const ComponentIds = {
  Table: 'Table',
  TableBody: 'TableBody',
  TableRow: 'TableRow',
  TableCell: 'TableCell',
  TableEditableCell: 'TableEditableCell',
  TableToolbar: 'TableToolbar',
  TableToolbarActions: 'TableToolbarActions',
  TableHeader: 'TableHeader',
  TableHeaderRow: 'TableHeaderRow',
  TableHeaderCell: 'TableHeaderCell',
  TableFooter: 'TableFooter',
  TableFooterRow: 'TableFooterRow',
  TableFooterCell: 'TableFooterCell',
  VirtualizedTable: 'VirtualizedTable',
  TablePagination: 'TablePagination',
};

export { ComponentIds };
